// @ts-nocheck
import React from 'react';
import useFetchPartner from '../useFetchPartner';
import { useTranslation } from '../../i18n/LanguageContext';
import { BanknotesIcon, BuildingOffice2Icon, DocumentTextIcon, EnvelopeIcon, GlobeAltIcon, IdentificationIcon, MapPinIcon } from '@heroicons/react/24/outline';

const normalizeExternalUrl = (url?: string) => {
  if (!url) return '';
  const value = url.trim();
  if (!value) return '';
  if (value.startsWith('http://') || value.startsWith('https://')) return value;
  return `https://${value}`;
};

export const PartnerInfo = () => {
  const { t } = useTranslation();
  const jwtToken = sessionStorage.getItem('jwt');
  const data = useFetchPartner(jwtToken);
  const item = (label, value, Icon, wide = false, mono = false) => (
    <div className={`rounded-2xl border border-gray-100 bg-gray-50/70 p-4 transition hover:border-green-cl/20 hover:bg-white hover:shadow-sm ${wide ? 'md:col-span-2' : ''}`}>
      <dt className="flex items-center gap-2 text-xs font-bold uppercase tracking-[0.12em] text-gray-400">
        <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-white text-green-cl shadow-sm ring-1 ring-gray-100"><Icon className="h-4 w-4" /></span>
        {label}
      </dt>
      <dd className={`mt-3 break-words text-sm font-semibold text-gray-900 ${mono ? 'font-mono tracking-wide' : ''}`}>{value || '-'}</dd>
    </div>
  );

  return (
    <section className="overflow-hidden rounded-3xl border border-gray-100 bg-white shadow-xl shadow-gray-200/60">
      <div className="flex flex-col gap-4 border-b border-gray-100 px-6 py-6 sm:flex-row sm:items-center sm:justify-between sm:px-8">
        <div>
          <p className="text-xs font-bold uppercase tracking-[0.24em] text-green-cl">{t('profile.myDetails')}</p>
          <h2 className="mt-1.5 text-2xl font-black text-gray-950">{t('profile.partnerData')}</h2>
          <p className="mt-1 text-sm text-gray-500">{t('profile.partnerDescription')}</p>
        </div>
        <span className="inline-flex w-fit items-center gap-2 rounded-full bg-green-50 px-3.5 py-2 text-xs font-bold text-green-800 ring-1 ring-green-100">
          <span className="h-2 w-2 rounded-full bg-green-500" />{data.name || t('profile.partnerData')}
        </span>
      </div>
      <div className="p-6 sm:p-8">
        <dl className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3">
          {item(t('settings.name'), data.name, BuildingOffice2Icon)}
          {item('NIF', data.nif, IdentificationIcon, false, true)}
          {item('Email', data.email, EnvelopeIcon)}
          {item('IBAN', data.iban, BanknotesIcon, false, true)}
          {item('BIC/SWIFT', data.bicSwift, BanknotesIcon, false, true)}
          {item(t('profile.address'), `${data.address || '-'}${data.zipCode ? ', ' + data.zipCode : ''}`, MapPinIcon)}
          <div className="rounded-2xl border border-gray-100 bg-gray-50/70 p-4 transition hover:border-green-cl/20 hover:bg-white hover:shadow-sm">
            <dt className="flex items-center gap-2 text-xs font-bold uppercase tracking-[0.12em] text-gray-400"><span className="flex h-8 w-8 items-center justify-center rounded-lg bg-white text-green-cl shadow-sm ring-1 ring-gray-100"><GlobeAltIcon className="h-4 w-4" /></span>Website</dt>
            <dd className="mt-3 break-all text-sm font-semibold text-green-cl">{data.url ? <a href={normalizeExternalUrl(data.url)} target="_blank" rel="noreferrer" className="hover:underline">{data.url}</a> : '-'}</dd>
          </div>
          {item(t('clients.notes'), data.notes, DocumentTextIcon, true)}
        </dl>
      </div>
    </section>
  );
};

export default PartnerInfo;
